import React, { useState } from "react";
import "./Navbar.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { TiThMenu } from "react-icons/ti";
import Cookies from "js-cookie";
const Nvabar = () => {
  const [hamburger, setham] = useState("ham1");
  const navigate = useNavigate();

  const onC = () => {
    if (hamburger == "ham1") {
      setham("ham");
      console.log(hamburger);
    } else {
      setham("ham1");
      console.log(hamburger);
    }
  };

  const logout = async () => {
    await Cookies.remove("token");
    navigate("/");
  };
  return (
    <div className="navbar">
      <div className="main">
        <div className="left">
          <Link to="/home">
            <h2>BLOG IT.</h2>
          </Link>
        </div>
        <div
          className="icon"
          onClick={() => {
            onC();
          }}
        >
          <TiThMenu />
        </div>
        <div className="right">
          <Link to={"/home/Health"}>Health </Link>
          <Link to={"/home/Tech"}>Tech </Link>
          <Link to={"/home/Travel"}>Travel </Link>
          <div className="dropdown">
            <TiThMenu size={25} />
            <div className="drop">
              <ul>
                <Link to="/new">
                  <li>New Post</li>
                </Link>

                <li>
                  <button
                    onClick={() => {
                      logout();
                    }}
                  >
                    Log out
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className={hamburger}>
        <li>
          <Link to={"/home/Health"}>Health </Link>
          <Link to={"/home/Tech"}>Tech </Link>
          <Link to={"/home/Travel"}>Travel </Link>
          <Link to="/new">
            {" "}
            <li>New Post</li>
          </Link>
        </li>
      </div>
    </div>
  );
};

export default Nvabar;
